import { render, staticRenderFns } from "./question4in1.vue?vue&type=template&id=1040d60c&scoped=true&"
import script from "./question4in1.vue?vue&type=script&lang=js&"
export * from "./question4in1.vue?vue&type=script&lang=js&"
import style0 from "./question4in1.vue?vue&type=style&index=0&id=1040d60c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040d60c",
  null
  
)

export default component.exports